import { IconProps } from "../../utils/global-types/global-types";

const UtmMediumIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M12.071 8.608a.457.457 0 1 0 .647.646 5.263 5.263 0 0 0 0-7.434.457.457 0 1 0-.647.646 4.347 4.347 0 0 1 0 6.142M5.284 9.256a5.26 5.26 0 0 1 0-7.438.455.455 0 0 1 .645 0 .46.46 0 0 1 0 .65 4.35 4.35 0 0 0 0 6.139.46.46 0 0 1 0 .649.46.46 0 0 1-.645 0"
      ></path>
      <path
        fill="currentColor"
        d="M6.578 3.112a.455.455 0 0 1 .645 0 .46.46 0 0 1 0 .649 2.516 2.516 0 0 0 0 3.552.46.46 0 0 1 0 .65.46.46 0 0 1-.645 0 3.43 3.43 0 0 1 0-4.851M10.78 7.313a2.516 2.516 0 0 0 0-3.552.46.46 0 0 1 0-.65.455.455 0 0 1 .644 0 3.43 3.43 0 0 1 0 4.851.46.46 0 0 1-.644 0 .46.46 0 0 1 0-.649"
      ></path>
      <path
        fill="currentColor"
        d="M13.083 15.688 9.623 7.01c.576-.247.978-.813.978-1.472 0-.882-.718-1.6-1.6-1.6s-1.6.718-1.6 1.6c0 .659.402 1.225.978 1.472l-3.46 8.677a.46.46 0 0 0 .256.594.46.46 0 0 0 .594-.256l.06-.155L9 13.114l3.168 2.757.064.155a.46.46 0 0 0 .594.256.46.46 0 0 0 .256-.594M6.57 14.015l.896-2.24.841.731zm1.253-3.14L9 7.915l1.18 2.958L9 11.898zm1.874 1.631.841-.731.896 2.24z"
      ></path>
    </svg>
  );
};

export default UtmMediumIcon;
